export enum SquareMultiplierEnum {
    Normal = 'NORMAL',
    DoubleLetter = 'DOUBLELETTER',
    TripleLetter = 'TRIPLELETTER',
    DoubleWord = 'DOUBLEWORD',
    TripleWord = 'TRIPLEWORD'
}